
import CommonUtils from "@/common-utils";
import CommonImageViewer from "@/components/CommonImageViewer.vue";
import UgcProfile from "@/components/UgcProfile.vue";
import UgcDetailComponent from "@/components/UgcDetailComponent.vue";
import Constants from "@/constants";
import { BeautyProfileMemberVO } from "@/views/biz/join/vo/join.vo";
import { MstUgcTagVO, RelUgcProductVO, SlvUgcCategoryVO, SlvUgcImgVO, SlvUgcReplyOVO, UgcVO } from "@/views/biz/ugc/vo/ugc.vo";
import axios from "axios";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import Teleport from "vue2-teleport";

@Component({
  components: { CommonImageViewer, Teleport, UgcProfile, UgcDetailComponent },
})
export default class Ugcs extends Vue {
  //-------------------------------
  //data
  //-------------------------------
  ajaxInited = false;
  busy = false;
  active = true;
  useSorting = true;
  orderBy = "regDate";
  isInfluencer = false; // 피드 인플루언서 여부체크
  ugcCategoryCd?: number | null = null;

  @Prop() keyword!: string;
  @Prop() productCd!: string; // product 상세
  @Prop() useTag!: boolean; // 태그 사용여부
  @Prop() reviewType!: string; //마이페이지 UGC 타입(구매/일반)
  @Prop({ default: false }) useFilter!: boolean; // 검색필터 사용여부
  @Prop() isBest!: boolean; // 베스트리뷰 혹은 인기유저임?
  @Prop({ default: false }) isLimit!: boolean; // 목록 개수 제한..+누더기
  @Prop() ugcCd!: number; 
  @Prop() ugcTypeCd!: string;
  @Prop() targetMemCd!: string; // 특정사용자의 UGC목록만 보여줄때
  @Prop({ default: null }) categoryCd?: number;  // 톡톡 디테일 화면에서 상단 카테고리 클릭시
  @Prop({ default: true })
  active2!: boolean; // 부모창 active 임?(메뉴에서 사용함)
  tags: Array<SlvUgcCategoryVO> = [];

  ugcs: Array<UgcVO> = [];
  replies: Array<SlvUgcReplyOVO> = [];

  // 상품 이미지 swiper
  swiperReviewImgOptions = {
    slidesPerView: 1,
    lazy: true,
    loop: false,
    freeMode: false,
    pagination: {
      el: ".swiper-pagination",
      type: "fraction",
    },
  };

  swiperFeedKeywordOptions = {
    slidesPerView: "auto",
    spaceBetween: 6,
  };

  //ugc products
  swiperUgcProducts = {
    slidesPerView: this.$isMobile ? 1.5 : 2.2,
    spaceBetween: this.$isMobile ? 1 : 10,
  };

  $commonUtils = CommonUtils; // 이거 안하면 왜 오류나는지 모르겠음. App.vue 에서 prototype에 선언해줘도 뭐라고 함. 파서 오류 같음

  //-------------------------------
  // methods
  //-------------------------------

  // 이미지 전체화면 보기
  // showFullscreenImage(review: ReviewVO) {
  //   this.$router.push({ name: "ImageViewer", params: { images: review.files as any } });
  // }

  //computed
  //리뷰 : 01 , 피드 : 02 카테고리 불러올때 사용됨 , 톡톡: 03
  get ugcType() {
    switch (this.ugcTypeCd) {
      case "047001":
        return "01";
      case "047002":
        return "02";
      case "047011":
        return "03";  
      default:
        return "";
    }
  }

  // 게시판 여부
  get isBoard() {
    return this.ugcTypeCd == '047011';
  }
  // watch
  //인플루언서 버튼 클릭
  @Watch("isInfluencer")
  onInfluencerChanged() {
    this.search(false);
  }

  @Watch("keyword")
  onKeywordChanged() {
    this.search(false);
  }

  @Watch("ugcCategoryCd")
  onCategoryChanged() {
    this.search(false);
  }

  // textarea 개행 문자 변경. \n -> <br>
  getConvertedUgcText(text: string) {
    return text.replace(/\n/g, "<br>");
  }

  // 좋아요
  btnLike(item: UgcVO) {
    const params = { targetCd: item.ugcCd, ugcTypeCd: this.ugcTypeCd };
    if (item.liked == 0) {
      axios.post(`/ugc/like`, params).then(() => {
        item.liked = 1;
        item.likeCount++;
        return;
      });
      return;
    }
    axios.delete(`/ugc/like`, { params }).then(() => {
      item.liked = 0;
      item.likeCount--;
      return;
    });
  }
  

  // 상단 태그 클릭
  onTopTagClicked(tag?: SlvUgcCategoryVO) {
    if (!tag) {
      // 전체
      this.$emit("update:keyword", "");
      this.ugcCategoryCd = null;
      return;
    }

    switch (this.ugcTypeCd) {
      case "047001":
        // 리뷰면 키워드 검색
        this.$emit("update:keyword", tag.ugcCategoryNm);
        break;
      case "047002":
      case "047011":
      default:
        this.ugcCategoryCd = tag.ugcCategoryCd;
        break;
    }
  }

  // 정렬
  toggleSort() {
    const orderBys = ["regDate", "likeCount"];

    // 정렬 누르면 다음 정렬로
    if (this.useSorting) {
      let i = 1;
      orderBys.forEach((orderBy) => {
        if (this.orderBy === orderBy) {
          if (i == orderBys.length) {
            i = 0;
          }
          this.orderBy = orderBys[i];
          return;
        }
        i++;
      });
    }
    this.search();
  }
 
  // review 목록
  search(loadMore?: boolean) {
    this.busy = true;
    this.ajaxInited = false;

    if (!loadMore) {
      this.ugcs = [];
    }
    const params = {
      keyword: this.keyword,
      productCd: this.productCd,
      isBest: this.isBest,
      useTag: !loadMore && this.useTag, // 최초 로딩시에만 필요함
      reviewType: this.reviewType,
      orderBy: this.orderBy,
      isInfluencer: this.isInfluencer,
      pageStart: this.ugcs.length,
      pageSize: 10,
      ugcCategoryCd: this.ugcCategoryCd,
      ugcCd: this.ugcCd,
      ugcTypeCd: this.ugcTypeCd,
      ugcType: this.ugcType,
      targetMemCd: this.targetMemCd,
      isUgcList: this.$route.name === 'BestReviews' ||  this.$route.name === 'Main'
    };
    // 상품 상세에선 3개만 가져옴
    if (this.isLimit) {
      params.pageSize = 3;
    }

    axios.get("/ugc/ugcs", { params: params }).then((r) => {
      r.data.feedCategories && (this.tags = r.data.feedCategories.filter( function(val: any){
      return val.ugcCategoryCd != 32;
       })
    );

      // ugcs 안에 ugcTags, ugcFiles, ugcProducts 들어간 데이터 형태로 가공
      const ugcs = r.data.feeds;
      ugcs.forEach((ugc: UgcVO) => {
        const ugcTags = [] as Array<MstUgcTagVO>;
        const ugcFiles = [] as Array<SlvUgcImgVO>;
        const ugcProducts = [] as Array<RelUgcProductVO>;
        const ugcBeautyProfileMembers = [] as Array<BeautyProfileMemberVO>;
        const ugcReplies = [] as Array<SlvUgcReplyOVO>;

        ugc.tags = ugcTags;
        ugc.files = ugcFiles;
        ugc.products = ugcProducts;
        ugc.beautyProfileMembers = ugcBeautyProfileMembers;
        ugc.replies = ugcReplies;

        (r.data.feedTags as Array<MstUgcTagVO>).forEach((ugcTag) => {
          if (ugcTag.ugcCd === ugc.ugcCd) {
            ugcTags.push(ugcTag);
          }
        });
        (r.data.feedFiles as Array<SlvUgcImgVO>).forEach((ugcFile) => {
          if (ugcFile.ugcCd === ugc.ugcCd) {
            ugcFiles.push(ugcFile);
          }
        });
        (r.data.feedProducts as Array<RelUgcProductVO>).forEach((ugcProduct) => {
          if (ugcProduct.ugcCd === ugc.ugcCd) {
            ugcProducts.push(ugcProduct);
          }
        });
        (r.data.beautyProfileMembers as Array<BeautyProfileMemberVO>).forEach((ugcBeautyProfileMember) => {
          if (ugcBeautyProfileMember.memCd === ugc.memCd) {
            ugcBeautyProfileMembers.push(ugcBeautyProfileMember);
          }
        });
        (r.data.replies as Array<SlvUgcReplyOVO>).forEach((ugcReply) => {
          if (ugcReply.ugcCd === ugc.ugcCd) {
            ugcReplies.push(ugcReply);
          }
        });
      });
      // 상품
      // 가공 후 넣어야 state에 영향 없음.
      this.ugcs = this.ugcs.concat(ugcs as Array<UgcVO>);

      this.ajaxInited = true;
      if (ugcs && ugcs.length && !this.isLimit) {
        this.busy = false;
      }
      this.onLayoutUpdated();
      // 필터 등 목록이 새로 설정되면 스크롤 탑
      loadMore == false && window.scrollTo({ top: Constants.MENU_POSITION_TOP });
    });
  }

  onLayoutUpdated() {
    this.$nextTick(() => {
      this.$emit("layout-update");
    });
  }

  //더보기
  onLoadMore() {
    if (!this.active || !this.active2) {
      return;
    }
    this.search(true);
  }
  activated(): void {    
    if(this.categoryCd){
      this.ugcCategoryCd = this.categoryCd;
    }
    this.active = true;
  }
  deactivated(): void {
    this.active = false;
  }

  isDropdownOpened = false;

  // initialized events
  created(): void {
    //톡톡 디테일 화면에서 불러올 두번 호출됨
    if(this.categoryCd){
      return
    }
    this.search();
  }
}
